import { BetrokkenTrein, useGetDossierBetrokkenTreinenById } from "@/entities/betrokken-treinen";
import { Button, Card, Empty, EmptyDescription, Icon } from "@/shared/components";
import { UseFormReturn } from "react-hook-form";
import { AddTreinFormData } from "./add-betrokken-trein-dialog";

type SpoorwebTreinenProps = {
    dossierNummer: string;
    form: UseFormReturn<AddTreinFormData>;
};

export function SpoorwebTreinen({ dossierNummer, form }: SpoorwebTreinenProps) {
    const {
        data: spoorwebTreinen,
        error,
        isPending,
    } = useGetDossierBetrokkenTreinenById(dossierNummer, (treinen) => treinen.filter((trein) => !trein.isRelevant));

    if (error || isPending) return null;

    if (spoorwebTreinen.length === 0) {
        return (
            <Empty>
                <EmptyDescription className="py-4">In Spoorweb zijn geen betrokken of gestrande treinen bekend</EmptyDescription>
            </Empty>
        );
    }
    return (
        <Card className="py-0">
            <ul>
                {spoorwebTreinen.map((trein) => (
                    <li key={trein.id} className="border-b last:border-b-0">
                        <SpoorwebTreinItem key={trein.id} form={form} trein={trein} />
                    </li>
                ))}
            </ul>
        </Card>
    );
}

type SpoorwebTreinItemProps = {
    form: UseFormReturn<AddTreinFormData>;
    trein: BetrokkenTrein;
};

function SpoorwebTreinItem({ form, trein }: SpoorwebTreinItemProps) {
    function handleTrainSelection() {
        form.setValue("treinId", String(trein.id));
        form.setValue("treintype", trein.treinType.toUpperCase());
        form.setValue("treinnummer", String(trein.treinNummer));
        form.setValue("materieelAanduiding", trein.materieel?.aanduiding?.toUpperCase() ?? "");
        form.setValue("materieelAantalBakken", String(trein.materieel?.aantalBakken ?? ""));
    }

    return (
        <Button
            type="button"
            variant="tertiary"
            onClick={handleTrainSelection}
            className="text-content-emphasis border-default flex w-full items-center gap-3 rounded-none border-0 p-3 font-normal uppercase"
        >
            <Icon name="train" />
            <span>{BetrokkenTrein.formatTrainLabel(trein)}</span>
            <span className="text-x text-content-subtle ml-auto flex items-center gap-2">
                {trein.materieel?.aanduiding} {trein.materieel?.aantalBakken}
                <Icon name="chevron-right" />
            </span>
        </Button>
    );
}
